import { Box } from '@palmetto/palmetto-components';

import { OrganizationActivity } from '../../Activity/OrganizationActivity';

const History = () => {
  return (
    <Box>
      <OrganizationActivity />
    </Box>
  );
};

export default History;
